import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import O2Button from "./o2-button";

function O2PopupMessageItem(props) {
  var _useState = useState(true),
      open = _useState[0],
      setOpen = _useState[1];

  var popupRef = useRef(null);

  var children = props.children,
      className = props.className,
      closeBtn = props.closeBtn,
      onClose = props.onClose,
      color = props.color,
      itemRemoving = props.itemRemoving,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "closeBtn", "onClose", "color", "itemRemoving"]);

  var onCloseWrapper = function onCloseWrapper() {
    if (!onClose) {
      return;
    }

    if (itemRemoving) {
      if (open) {
        setOpen(false);
        var maxNumberOfIterations = 10;
        var numberOfIterations = 0;
        var interval = setInterval(function () {
          if (!popupRef.current) {
            clearInterval(interval);
            onClose();
            return;
          }

          var opacity = window.getComputedStyle(popupRef.current).getPropertyValue("opacity");

          if (opacity === "0") {
            clearInterval(interval);
            onClose();
            return;
          }

          if (++numberOfIterations >= maxNumberOfIterations) {
            clearInterval(interval);
            onClose();
          }
        }, 100);
      }
    } else {
      onClose();
    }
  };

  var classes = classNames(className, "o2-popup-message__item", color ? "o2-popup-message__item--" + color : false, {
    "o2-popup-message__item--removing": !open
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes,
    ref: popupRef
  }), children, closeBtn && /*#__PURE__*/React.createElement("div", {
    className: "o2-popup-message__close"
  }, /*#__PURE__*/React.createElement(O2Button, {
    size: "small",
    icon: "cross",
    color: "transparent",
    onClick: onCloseWrapper
  })));
}

O2PopupMessageItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeBtn: PropTypes.bool,
  color: PropTypes.oneOf(["success", "warning", "danger", "internal"]),
  itemRemoving: PropTypes.bool,
  onClose: PropTypes.func
};
O2PopupMessageItem.defaultProps = {
  closeBtn: true
};
export default O2PopupMessageItem;